import React from 'react'
import { Map } from 'lucide-react'
import { useEventContext } from '../EventContext'
import { ScheduleConfigItemsPanel } from './ScheduleConfigItemsPanel'

export const ScheduleConfig: React.FC = () => {
  const { event } = useEventContext()

  if (!event) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 mb-2">
        <Map className="h-5 w-5" />
        <h2 className="text-lg font-semibold">Schedule Configuration</h2>
      </div>
      <p className="text-sm text-muted-foreground -mt-4">
        Manage locations and positions used when scheduling shifts for {event?.name || 'this event'}.
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ScheduleConfigItemsPanel kind="location" />
        <ScheduleConfigItemsPanel kind="position" />
      </div>
    </div>
  )
}
